<template>
  <div class="rb-steps-count">
    Step {{ currentStep + 1 }} / {{ totalSteps }}
  </div>
</template>
<script>
/**
 * Progress counter for current step
 *
 * @props
 * currentStep: Number
 * totalSteps: Number
 */
export default {
  props: {
    currentStep: {
      type: Number,
      default: 1,
    },
    totalSteps: {
      type: Number,
      default: 1,
    },
  },
};
</script>
